import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./ImageViewer.scss";

type ImageViewerProps = {
  src: string;
  alt: string;
  onClose: () => void;
};

export function ImageViewer({ src, alt, onClose }: ImageViewerProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const close = useRef(onClose);
  close.current = onClose;

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") close.current();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);

  return createPortal(
    <div className="image-viewer" role="dialog" aria-modal="true" aria-label={alt ? `Imagine mărită: ${alt}` : "Imagine mărită"} onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
      <button ref={closeButtonRef} className="image-viewer__close" type="button" aria-label="Închide imaginea" onClick={onClose}>×</button>
      <img src={src} alt={alt} />
    </div>,
    document.body
  );
}
